import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'subscribed-portfolios',
  action: ActionType.READ,
};

const createPermission = {
  resource: 'subscribed-portfolio',
  action: ActionType.CREATE,
};
const updatePermission = {
  resource: 'subscribed-portfolio',
  action: ActionType.UPDATE,
};
const readPermission = {
  resource: 'subscribed-portfolio',
  action: ActionType.READ,
};
const deletePermission = {
  resource: 'subscribed-portfolio',
  action: ActionType.DELETE,
};
const statusUpdatePermission = {
  resource: 'subscribed-portfolio-status',
  action: ActionType.UPDATE,
};

export const SubscribedPortfolio = {
  list: listPermission,
  read: readPermission,
  create: createPermission,
  update: updatePermission,
  delete: deletePermission,
  statusUpdate: statusUpdatePermission,
};
